import React from 'react'
import './Section.scss'

const SectionHeader = ({children}) => {
    return (
        <header className="section-header">
            { children }
        </header>
    );
};

export default SectionHeader


// WEBPACK FOOTER //
// ./src/components/Header/Section.js